import { default as categories9WsjfDz7dFMeta } from "/tmp/8dda472cd6067b3/pages/admin/cms/categories.vue?macro=true";
import { default as indexBmNdLs3rTiMeta } from "/tmp/8dda472cd6067b3/pages/admin/enrolment/closeYear/index.vue?macro=true";
import { default as index2MY40L5bkdMeta } from "/tmp/8dda472cd6067b3/pages/admin/enrolment/list/index.vue?macro=true";
import { default as index05WL1LNUPUMeta } from "/tmp/8dda472cd6067b3/pages/admin/enrolment/process/index.vue?macro=true";
import { default as registerBdl8LeqvTdMeta } from "/tmp/8dda472cd6067b3/pages/admin/enrolment/register.vue?macro=true";
import { default as listuh6fgGVN2YMeta } from "/tmp/8dda472cd6067b3/pages/admin/finance/list.vue?macro=true";
import { default as paymentswpYak3H8EAMeta } from "/tmp/8dda472cd6067b3/pages/admin/finance/payments.vue?macro=true";
import { default as borrowyDgcPZijKuMeta } from "/tmp/8dda472cd6067b3/pages/admin/library/borrow.vue?macro=true";
import { default as homeMmSTTgBjcmMeta } from "/tmp/8dda472cd6067b3/pages/admin/library/home.vue?macro=true";
import { default as loansbu4RrePefjMeta } from "/tmp/8dda472cd6067b3/pages/admin/library/loans.vue?macro=true";
import { default as searcherjyXxPjqYAoMeta } from "/tmp/8dda472cd6067b3/pages/admin/library/searcher.vue?macro=true";
import { default as manager4Nv48GTGMHMeta } from "/tmp/8dda472cd6067b3/pages/admin/mgsystems/manager.vue?macro=true";
import { default as indexjmm2lcfVt6Meta } from "/tmp/8dda472cd6067b3/pages/admin/school/cohort/index.vue?macro=true";
import { default as indexrPWXgFvJirMeta } from "/tmp/8dda472cd6067b3/pages/admin/school/curriculum/index.vue?macro=true";
import { default as indexTdph3ZhjEKMeta } from "/tmp/8dda472cd6067b3/pages/admin/school/dua/index.vue?macro=true";
import { default as indexpt0vbEmCK2Meta } from "/tmp/8dda472cd6067b3/pages/admin/school/evaluationSystems/index.vue?macro=true";
import { default as indexIbRcLecc4cMeta } from "/tmp/8dda472cd6067b3/pages/admin/school/lnut/index.vue?macro=true";
import { default as indexIflWUcHcpZMeta } from "/tmp/8dda472cd6067b3/pages/admin/school/rooms/index.vue?macro=true";
import { default as indexB1kTK77MFBMeta } from "/tmp/8dda472cd6067b3/pages/admin/system/config/index.vue?macro=true";
import { default as indexVrQK14mBr6Meta } from "/tmp/8dda472cd6067b3/pages/admin/system/profile/index.vue?macro=true";
import { default as indexlXui7AMM3nMeta } from "/tmp/8dda472cd6067b3/pages/admin/system/roles/index.vue?macro=true";
import { default as indexBwV1ZVOW6mMeta } from "/tmp/8dda472cd6067b3/pages/admin/system/simpleEnrolments/index.vue?macro=true";
import { default as admisiones7slCcQbzHNMeta } from "/tmp/8dda472cd6067b3/pages/admisiones.vue?macro=true";
import { default as index0xkrdlsDO0Meta } from "/tmp/8dda472cd6067b3/pages/agenda/index.vue?macro=true";
import { default as chatLR90JZjppHMeta } from "/tmp/8dda472cd6067b3/pages/chat.vue?macro=true";
import { default as _91_46_46_46slug_9382fBMZ6W5yMeta } from "/tmp/8dda472cd6067b3/pages/cicle/home/[id]/[subject]/[[tab]]/[[subid]]/[...slug].vue?macro=true";
import { default as _91slug_93ohz0EzoVMmMeta } from "/tmp/8dda472cd6067b3/pages/circulares/[category]/[slug].vue?macro=true";
import { default as indexvwTldCSfQtMeta } from "/tmp/8dda472cd6067b3/pages/circulares/[category]/index.vue?macro=true";
import { default as indexmT5auE57z0Meta } from "/tmp/8dda472cd6067b3/pages/circulares/index.vue?macro=true";
import { default as _91slug_93YH3hzr1ZZGMeta } from "/tmp/8dda472cd6067b3/pages/cms/[category]/[slug].vue?macro=true";
import { default as index5VkovhHsWDMeta } from "/tmp/8dda472cd6067b3/pages/cms/[category]/index.vue?macro=true";
import { default as _91id_936Va1ZS7lT7Meta } from "/tmp/8dda472cd6067b3/pages/cms/banner/[id].vue?macro=true";
import { default as _91id_93jjNPZi6rpyMeta } from "/tmp/8dda472cd6067b3/pages/cms/home/[id].vue?macro=true";
import { default as contactoyuCPyL0995Meta } from "/tmp/8dda472cd6067b3/pages/contacto.vue?macro=true";
import { default as myBwQ96bJOcUMeta } from "/tmp/8dda472cd6067b3/pages/finance/my.vue?macro=true";
import { default as forgotPasswordXmZcayfKDTMeta } from "/tmp/8dda472cd6067b3/pages/forgotPassword.vue?macro=true";
import { default as listXsvGouEXZTMeta } from "/tmp/8dda472cd6067b3/pages/hhrr/employees/list.vue?macro=true";
import { default as eppsIuYDGvK89aMeta } from "/tmp/8dda472cd6067b3/pages/hhrr/profesiogram/epps.vue?macro=true";
import { default as examsZnoQRyvQ1aMeta } from "/tmp/8dda472cd6067b3/pages/hhrr/profesiogram/exams.vue?macro=true";
import { default as jobsgGStBEI7c9Meta } from "/tmp/8dda472cd6067b3/pages/hhrr/profesiogram/jobs.vue?macro=true";
import { default as managercekEmE88hKMeta } from "/tmp/8dda472cd6067b3/pages/hhrr/risk/manager.vue?macro=true";
import { default as risksNncAPadSLZMeta } from "/tmp/8dda472cd6067b3/pages/hhrr/risk/risks.vue?macro=true";
import { default as home3mwFEWbJsNMeta } from "/tmp/8dda472cd6067b3/pages/home.vue?macro=true";
import { default as mylQQYZXrVizMeta } from "/tmp/8dda472cd6067b3/pages/incidents/my.vue?macro=true";
import { default as indexKQG8XFEQeUMeta } from "/tmp/8dda472cd6067b3/pages/index.vue?macro=true";
import { default as linksMa3xR3ximbMeta } from "/tmp/8dda472cd6067b3/pages/links.vue?macro=true";
import { default as _91_91tab_93_93rqLlaSRblPMeta } from "/tmp/8dda472cd6067b3/pages/lnut/home/[id]/[section]/[[pk]]/[[tab]].vue?macro=true";
import { default as _91tab_93MRiaAMSh90Meta } from "/tmp/8dda472cd6067b3/pages/lnut/home/subject/[id]/[tab].vue?macro=true";
import { default as loginZZK6EXEGPIMeta } from "/tmp/8dda472cd6067b3/pages/login.vue?macro=true";
import { default as logout2y7kuGoFU4Meta } from "/tmp/8dda472cd6067b3/pages/logout.vue?macro=true";
import { default as noticiase7VaHLpbHYMeta } from "/tmp/8dda472cd6067b3/pages/noticias.vue?macro=true";
import { default as _91tab_9397SC3gd6PcMeta } from "/tmp/8dda472cd6067b3/pages/profile/settings/[tab].vue?macro=true";
import { default as _91token_930ycrhvM19HMeta } from "/tmp/8dda472cd6067b3/pages/resetPassword/[token].vue?macro=true";
import { default as licencia9ccz7HxvBbMeta } from "/tmp/8dda472cd6067b3/pages/rules/licencia.vue?macro=true";
import { default as manualLNPxFL9owuMeta } from "/tmp/8dda472cd6067b3/pages/rules/manual.vue?macro=true";
import { default as politicas0mp8IppUlfMeta } from "/tmp/8dda472cd6067b3/pages/rules/politicas.vue?macro=true";
import { default as terminos4k5m2XPwS8Meta } from "/tmp/8dda472cd6067b3/pages/rules/terminos.vue?macro=true";
import { default as myGJMUhaQI3UMeta } from "/tmp/8dda472cd6067b3/pages/schedule/my.vue?macro=true";
import { default as index3WyeU1RpzgMeta } from "/tmp/8dda472cd6067b3/pages/school/assistance/entrance/index.vue?macro=true";
import { default as indexZ1q96dlZUqMeta } from "/tmp/8dda472cd6067b3/pages/school/assistance/report/index.vue?macro=true";
import { default as indexx6TUrOUW9yMeta } from "/tmp/8dda472cd6067b3/pages/school/sico/index.vue?macro=true";
import { default as adminpiarXeYf0XYIvtMeta } from "/tmp/8dda472cd6067b3/pages/school/tracing/adminpiar.vue?macro=true";
import { default as characterization4IeQ6sD5WAMeta } from "/tmp/8dda472cd6067b3/pages/school/tracing/characterization.vue?macro=true";
import { default as coursesOPW10OMFkPMeta } from "/tmp/8dda472cd6067b3/pages/school/tracing/courses.vue?macro=true";
import { default as lowPerformanceDJdG7rpLvAMeta } from "/tmp/8dda472cd6067b3/pages/school/tracing/lowPerformance.vue?macro=true";
import { default as performanceiKvyrXH3xOMeta } from "/tmp/8dda472cd6067b3/pages/school/tracing/performance.vue?macro=true";
import { default as resources0KGogyglTDMeta } from "/tmp/8dda472cd6067b3/pages/school/tracing/resources.vue?macro=true";
import { default as indexP4MFeWCo1AMeta } from "/tmp/8dda472cd6067b3/pages/school/transport/index.vue?macro=true";
import { default as _91_46_46_46slug_93yMERMLUrMKMeta } from "/tmp/8dda472cd6067b3/pages/subject/home/[id]/[tab]/[[subid]]/[...slug].vue?macro=true";
import { default as testfyUrV7wzG9Meta } from "/tmp/8dda472cd6067b3/pages/test.vue?macro=true";
export default [
  {
    name: categories9WsjfDz7dFMeta?.name ?? "admin-cms-categories",
    path: categories9WsjfDz7dFMeta?.path ?? "/admin/cms/categories",
    meta: categories9WsjfDz7dFMeta || {},
    alias: categories9WsjfDz7dFMeta?.alias || [],
    redirect: categories9WsjfDz7dFMeta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/admin/cms/categories.vue").then(m => m.default || m)
  },
  {
    name: indexBmNdLs3rTiMeta?.name ?? "admin-enrolment-closeYear",
    path: indexBmNdLs3rTiMeta?.path ?? "/admin/enrolment/closeYear",
    meta: indexBmNdLs3rTiMeta || {},
    alias: indexBmNdLs3rTiMeta?.alias || [],
    redirect: indexBmNdLs3rTiMeta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/admin/enrolment/closeYear/index.vue").then(m => m.default || m)
  },
  {
    name: index2MY40L5bkdMeta?.name ?? "admin-enrolment-list",
    path: index2MY40L5bkdMeta?.path ?? "/admin/enrolment/list",
    meta: index2MY40L5bkdMeta || {},
    alias: index2MY40L5bkdMeta?.alias || [],
    redirect: index2MY40L5bkdMeta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/admin/enrolment/list/index.vue").then(m => m.default || m)
  },
  {
    name: index05WL1LNUPUMeta?.name ?? "admin-enrolment-process",
    path: index05WL1LNUPUMeta?.path ?? "/admin/enrolment/process",
    meta: index05WL1LNUPUMeta || {},
    alias: index05WL1LNUPUMeta?.alias || [],
    redirect: index05WL1LNUPUMeta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/admin/enrolment/process/index.vue").then(m => m.default || m)
  },
  {
    name: registerBdl8LeqvTdMeta?.name ?? "admin-enrolment-register",
    path: registerBdl8LeqvTdMeta?.path ?? "/admin/enrolment/register",
    meta: registerBdl8LeqvTdMeta || {},
    alias: registerBdl8LeqvTdMeta?.alias || [],
    redirect: registerBdl8LeqvTdMeta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/admin/enrolment/register.vue").then(m => m.default || m)
  },
  {
    name: listuh6fgGVN2YMeta?.name ?? "admin-finance-list",
    path: listuh6fgGVN2YMeta?.path ?? "/admin/finance/list",
    meta: listuh6fgGVN2YMeta || {},
    alias: listuh6fgGVN2YMeta?.alias || [],
    redirect: listuh6fgGVN2YMeta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/admin/finance/list.vue").then(m => m.default || m)
  },
  {
    name: paymentswpYak3H8EAMeta?.name ?? "admin-finance-payments",
    path: paymentswpYak3H8EAMeta?.path ?? "/admin/finance/payments",
    meta: paymentswpYak3H8EAMeta || {},
    alias: paymentswpYak3H8EAMeta?.alias || [],
    redirect: paymentswpYak3H8EAMeta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/admin/finance/payments.vue").then(m => m.default || m)
  },
  {
    name: borrowyDgcPZijKuMeta?.name ?? "admin-library-borrow",
    path: borrowyDgcPZijKuMeta?.path ?? "/admin/library/borrow",
    meta: borrowyDgcPZijKuMeta || {},
    alias: borrowyDgcPZijKuMeta?.alias || [],
    redirect: borrowyDgcPZijKuMeta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/admin/library/borrow.vue").then(m => m.default || m)
  },
  {
    name: homeMmSTTgBjcmMeta?.name ?? "admin-library-home",
    path: homeMmSTTgBjcmMeta?.path ?? "/admin/library/home",
    meta: homeMmSTTgBjcmMeta || {},
    alias: homeMmSTTgBjcmMeta?.alias || [],
    redirect: homeMmSTTgBjcmMeta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/admin/library/home.vue").then(m => m.default || m)
  },
  {
    name: loansbu4RrePefjMeta?.name ?? "admin-library-loans",
    path: loansbu4RrePefjMeta?.path ?? "/admin/library/loans",
    meta: loansbu4RrePefjMeta || {},
    alias: loansbu4RrePefjMeta?.alias || [],
    redirect: loansbu4RrePefjMeta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/admin/library/loans.vue").then(m => m.default || m)
  },
  {
    name: searcherjyXxPjqYAoMeta?.name ?? "admin-library-searcher",
    path: searcherjyXxPjqYAoMeta?.path ?? "/admin/library/searcher",
    meta: searcherjyXxPjqYAoMeta || {},
    alias: searcherjyXxPjqYAoMeta?.alias || [],
    redirect: searcherjyXxPjqYAoMeta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/admin/library/searcher.vue").then(m => m.default || m)
  },
  {
    name: manager4Nv48GTGMHMeta?.name ?? "admin-mgsystems-manager",
    path: manager4Nv48GTGMHMeta?.path ?? "/admin/mgsystems/manager",
    meta: manager4Nv48GTGMHMeta || {},
    alias: manager4Nv48GTGMHMeta?.alias || [],
    redirect: manager4Nv48GTGMHMeta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/admin/mgsystems/manager.vue").then(m => m.default || m)
  },
  {
    name: indexjmm2lcfVt6Meta?.name ?? "admin-school-cohort",
    path: indexjmm2lcfVt6Meta?.path ?? "/admin/school/cohort",
    meta: indexjmm2lcfVt6Meta || {},
    alias: indexjmm2lcfVt6Meta?.alias || [],
    redirect: indexjmm2lcfVt6Meta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/admin/school/cohort/index.vue").then(m => m.default || m)
  },
  {
    name: indexrPWXgFvJirMeta?.name ?? "admin-school-curriculum",
    path: indexrPWXgFvJirMeta?.path ?? "/admin/school/curriculum",
    meta: indexrPWXgFvJirMeta || {},
    alias: indexrPWXgFvJirMeta?.alias || [],
    redirect: indexrPWXgFvJirMeta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/admin/school/curriculum/index.vue").then(m => m.default || m)
  },
  {
    name: indexTdph3ZhjEKMeta?.name ?? "admin-school-dua",
    path: indexTdph3ZhjEKMeta?.path ?? "/admin/school/dua",
    meta: indexTdph3ZhjEKMeta || {},
    alias: indexTdph3ZhjEKMeta?.alias || [],
    redirect: indexTdph3ZhjEKMeta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/admin/school/dua/index.vue").then(m => m.default || m)
  },
  {
    name: indexpt0vbEmCK2Meta?.name ?? "admin-school-evaluationSystems",
    path: indexpt0vbEmCK2Meta?.path ?? "/admin/school/evaluationSystems",
    meta: indexpt0vbEmCK2Meta || {},
    alias: indexpt0vbEmCK2Meta?.alias || [],
    redirect: indexpt0vbEmCK2Meta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/admin/school/evaluationSystems/index.vue").then(m => m.default || m)
  },
  {
    name: indexIbRcLecc4cMeta?.name ?? "admin-school-lnut",
    path: indexIbRcLecc4cMeta?.path ?? "/admin/school/lnut",
    meta: indexIbRcLecc4cMeta || {},
    alias: indexIbRcLecc4cMeta?.alias || [],
    redirect: indexIbRcLecc4cMeta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/admin/school/lnut/index.vue").then(m => m.default || m)
  },
  {
    name: indexIflWUcHcpZMeta?.name ?? "admin-school-rooms",
    path: indexIflWUcHcpZMeta?.path ?? "/admin/school/rooms",
    meta: indexIflWUcHcpZMeta || {},
    alias: indexIflWUcHcpZMeta?.alias || [],
    redirect: indexIflWUcHcpZMeta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/admin/school/rooms/index.vue").then(m => m.default || m)
  },
  {
    name: indexB1kTK77MFBMeta?.name ?? "admin-system-config",
    path: indexB1kTK77MFBMeta?.path ?? "/admin/system/config",
    meta: indexB1kTK77MFBMeta || {},
    alias: indexB1kTK77MFBMeta?.alias || [],
    redirect: indexB1kTK77MFBMeta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/admin/system/config/index.vue").then(m => m.default || m)
  },
  {
    name: indexVrQK14mBr6Meta?.name ?? "admin-system-profile",
    path: indexVrQK14mBr6Meta?.path ?? "/admin/system/profile",
    meta: indexVrQK14mBr6Meta || {},
    alias: indexVrQK14mBr6Meta?.alias || [],
    redirect: indexVrQK14mBr6Meta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/admin/system/profile/index.vue").then(m => m.default || m)
  },
  {
    name: indexlXui7AMM3nMeta?.name ?? "admin-system-roles",
    path: indexlXui7AMM3nMeta?.path ?? "/admin/system/roles",
    meta: indexlXui7AMM3nMeta || {},
    alias: indexlXui7AMM3nMeta?.alias || [],
    redirect: indexlXui7AMM3nMeta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/admin/system/roles/index.vue").then(m => m.default || m)
  },
  {
    name: indexBwV1ZVOW6mMeta?.name ?? "admin-system-simpleEnrolments",
    path: indexBwV1ZVOW6mMeta?.path ?? "/admin/system/simpleEnrolments",
    meta: indexBwV1ZVOW6mMeta || {},
    alias: indexBwV1ZVOW6mMeta?.alias || [],
    redirect: indexBwV1ZVOW6mMeta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/admin/system/simpleEnrolments/index.vue").then(m => m.default || m)
  },
  {
    name: admisiones7slCcQbzHNMeta?.name ?? "admisiones",
    path: admisiones7slCcQbzHNMeta?.path ?? "/admisiones",
    meta: admisiones7slCcQbzHNMeta || {},
    alias: admisiones7slCcQbzHNMeta?.alias || [],
    redirect: admisiones7slCcQbzHNMeta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/admisiones.vue").then(m => m.default || m)
  },
  {
    name: index0xkrdlsDO0Meta?.name ?? "agenda",
    path: index0xkrdlsDO0Meta?.path ?? "/agenda",
    meta: index0xkrdlsDO0Meta || {},
    alias: index0xkrdlsDO0Meta?.alias || [],
    redirect: index0xkrdlsDO0Meta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/agenda/index.vue").then(m => m.default || m)
  },
  {
    name: chatLR90JZjppHMeta?.name ?? "chat",
    path: chatLR90JZjppHMeta?.path ?? "/chat",
    meta: chatLR90JZjppHMeta || {},
    alias: chatLR90JZjppHMeta?.alias || [],
    redirect: chatLR90JZjppHMeta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/chat.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_9382fBMZ6W5yMeta?.name ?? "cicle-home-id-subject-tab-subid-slug",
    path: _91_46_46_46slug_9382fBMZ6W5yMeta?.path ?? "/cicle/home/:id()/:subject()/:tab?/:subid?/:slug(.*)*",
    meta: _91_46_46_46slug_9382fBMZ6W5yMeta || {},
    alias: _91_46_46_46slug_9382fBMZ6W5yMeta?.alias || [],
    redirect: _91_46_46_46slug_9382fBMZ6W5yMeta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/cicle/home/[id]/[subject]/[[tab]]/[[subid]]/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93ohz0EzoVMmMeta?.name ?? "circulares-category-slug",
    path: _91slug_93ohz0EzoVMmMeta?.path ?? "/circulares/:category()/:slug()",
    meta: _91slug_93ohz0EzoVMmMeta || {},
    alias: _91slug_93ohz0EzoVMmMeta?.alias || [],
    redirect: _91slug_93ohz0EzoVMmMeta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/circulares/[category]/[slug].vue").then(m => m.default || m)
  },
  {
    name: indexvwTldCSfQtMeta?.name ?? "circulares-category",
    path: indexvwTldCSfQtMeta?.path ?? "/circulares/:category()",
    meta: indexvwTldCSfQtMeta || {},
    alias: indexvwTldCSfQtMeta?.alias || [],
    redirect: indexvwTldCSfQtMeta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/circulares/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: indexmT5auE57z0Meta?.name ?? "circulares",
    path: indexmT5auE57z0Meta?.path ?? "/circulares",
    meta: indexmT5auE57z0Meta || {},
    alias: indexmT5auE57z0Meta?.alias || [],
    redirect: indexmT5auE57z0Meta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/circulares/index.vue").then(m => m.default || m)
  },
  {
    name: _91slug_93YH3hzr1ZZGMeta?.name ?? "cms-category-slug",
    path: _91slug_93YH3hzr1ZZGMeta?.path ?? "/cms/:category()/:slug()",
    meta: _91slug_93YH3hzr1ZZGMeta || {},
    alias: _91slug_93YH3hzr1ZZGMeta?.alias || [],
    redirect: _91slug_93YH3hzr1ZZGMeta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/cms/[category]/[slug].vue").then(m => m.default || m)
  },
  {
    name: index5VkovhHsWDMeta?.name ?? "cms-category",
    path: index5VkovhHsWDMeta?.path ?? "/cms/:category()",
    meta: index5VkovhHsWDMeta || {},
    alias: index5VkovhHsWDMeta?.alias || [],
    redirect: index5VkovhHsWDMeta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/cms/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_936Va1ZS7lT7Meta?.name ?? "cms-banner-id",
    path: _91id_936Va1ZS7lT7Meta?.path ?? "/cms/banner/:id()",
    meta: _91id_936Va1ZS7lT7Meta || {},
    alias: _91id_936Va1ZS7lT7Meta?.alias || [],
    redirect: _91id_936Va1ZS7lT7Meta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/cms/banner/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_93jjNPZi6rpyMeta?.name ?? "cms-home-id",
    path: _91id_93jjNPZi6rpyMeta?.path ?? "/cms/home/:id()",
    meta: _91id_93jjNPZi6rpyMeta || {},
    alias: _91id_93jjNPZi6rpyMeta?.alias || [],
    redirect: _91id_93jjNPZi6rpyMeta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/cms/home/[id].vue").then(m => m.default || m)
  },
  {
    name: contactoyuCPyL0995Meta?.name ?? "contacto",
    path: contactoyuCPyL0995Meta?.path ?? "/contacto",
    meta: contactoyuCPyL0995Meta || {},
    alias: contactoyuCPyL0995Meta?.alias || [],
    redirect: contactoyuCPyL0995Meta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/contacto.vue").then(m => m.default || m)
  },
  {
    name: myBwQ96bJOcUMeta?.name ?? "finance-my",
    path: myBwQ96bJOcUMeta?.path ?? "/finance/my",
    meta: myBwQ96bJOcUMeta || {},
    alias: myBwQ96bJOcUMeta?.alias || [],
    redirect: myBwQ96bJOcUMeta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/finance/my.vue").then(m => m.default || m)
  },
  {
    name: forgotPasswordXmZcayfKDTMeta?.name ?? "forgotPassword",
    path: forgotPasswordXmZcayfKDTMeta?.path ?? "/forgotPassword",
    meta: forgotPasswordXmZcayfKDTMeta || {},
    alias: forgotPasswordXmZcayfKDTMeta?.alias || [],
    redirect: forgotPasswordXmZcayfKDTMeta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/forgotPassword.vue").then(m => m.default || m)
  },
  {
    name: listXsvGouEXZTMeta?.name ?? "hhrr-employees-list",
    path: listXsvGouEXZTMeta?.path ?? "/hhrr/employees/list",
    meta: listXsvGouEXZTMeta || {},
    alias: listXsvGouEXZTMeta?.alias || [],
    redirect: listXsvGouEXZTMeta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/hhrr/employees/list.vue").then(m => m.default || m)
  },
  {
    name: eppsIuYDGvK89aMeta?.name ?? "hhrr-profesiogram-epps",
    path: eppsIuYDGvK89aMeta?.path ?? "/hhrr/profesiogram/epps",
    meta: eppsIuYDGvK89aMeta || {},
    alias: eppsIuYDGvK89aMeta?.alias || [],
    redirect: eppsIuYDGvK89aMeta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/hhrr/profesiogram/epps.vue").then(m => m.default || m)
  },
  {
    name: examsZnoQRyvQ1aMeta?.name ?? "hhrr-profesiogram-exams",
    path: examsZnoQRyvQ1aMeta?.path ?? "/hhrr/profesiogram/exams",
    meta: examsZnoQRyvQ1aMeta || {},
    alias: examsZnoQRyvQ1aMeta?.alias || [],
    redirect: examsZnoQRyvQ1aMeta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/hhrr/profesiogram/exams.vue").then(m => m.default || m)
  },
  {
    name: jobsgGStBEI7c9Meta?.name ?? "hhrr-profesiogram-jobs",
    path: jobsgGStBEI7c9Meta?.path ?? "/hhrr/profesiogram/jobs",
    meta: jobsgGStBEI7c9Meta || {},
    alias: jobsgGStBEI7c9Meta?.alias || [],
    redirect: jobsgGStBEI7c9Meta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/hhrr/profesiogram/jobs.vue").then(m => m.default || m)
  },
  {
    name: managercekEmE88hKMeta?.name ?? "hhrr-risk-manager",
    path: managercekEmE88hKMeta?.path ?? "/hhrr/risk/manager",
    meta: managercekEmE88hKMeta || {},
    alias: managercekEmE88hKMeta?.alias || [],
    redirect: managercekEmE88hKMeta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/hhrr/risk/manager.vue").then(m => m.default || m)
  },
  {
    name: risksNncAPadSLZMeta?.name ?? "hhrr-risk-risks",
    path: risksNncAPadSLZMeta?.path ?? "/hhrr/risk/risks",
    meta: risksNncAPadSLZMeta || {},
    alias: risksNncAPadSLZMeta?.alias || [],
    redirect: risksNncAPadSLZMeta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/hhrr/risk/risks.vue").then(m => m.default || m)
  },
  {
    name: home3mwFEWbJsNMeta?.name ?? "home",
    path: home3mwFEWbJsNMeta?.path ?? "/home",
    meta: home3mwFEWbJsNMeta || {},
    alias: home3mwFEWbJsNMeta?.alias || [],
    redirect: home3mwFEWbJsNMeta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/home.vue").then(m => m.default || m)
  },
  {
    name: mylQQYZXrVizMeta?.name ?? "incidents-my",
    path: mylQQYZXrVizMeta?.path ?? "/incidents/my",
    meta: mylQQYZXrVizMeta || {},
    alias: mylQQYZXrVizMeta?.alias || [],
    redirect: mylQQYZXrVizMeta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/incidents/my.vue").then(m => m.default || m)
  },
  {
    name: indexKQG8XFEQeUMeta?.name ?? "index",
    path: indexKQG8XFEQeUMeta?.path ?? "/",
    meta: indexKQG8XFEQeUMeta || {},
    alias: indexKQG8XFEQeUMeta?.alias || [],
    redirect: indexKQG8XFEQeUMeta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/index.vue").then(m => m.default || m)
  },
  {
    name: linksMa3xR3ximbMeta?.name ?? "links",
    path: linksMa3xR3ximbMeta?.path ?? "/links",
    meta: linksMa3xR3ximbMeta || {},
    alias: linksMa3xR3ximbMeta?.alias || [],
    redirect: linksMa3xR3ximbMeta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/links.vue").then(m => m.default || m)
  },
  {
    name: _91_91tab_93_93rqLlaSRblPMeta?.name ?? "lnut-home-id-section-pk-tab",
    path: _91_91tab_93_93rqLlaSRblPMeta?.path ?? "/lnut/home/:id()/:section()/:pk?/:tab?",
    meta: _91_91tab_93_93rqLlaSRblPMeta || {},
    alias: _91_91tab_93_93rqLlaSRblPMeta?.alias || [],
    redirect: _91_91tab_93_93rqLlaSRblPMeta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/lnut/home/[id]/[section]/[[pk]]/[[tab]].vue").then(m => m.default || m)
  },
  {
    name: _91tab_93MRiaAMSh90Meta?.name ?? "lnut-home-subject-id-tab",
    path: _91tab_93MRiaAMSh90Meta?.path ?? "/lnut/home/subject/:id()/:tab()",
    meta: _91tab_93MRiaAMSh90Meta || {},
    alias: _91tab_93MRiaAMSh90Meta?.alias || [],
    redirect: _91tab_93MRiaAMSh90Meta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/lnut/home/subject/[id]/[tab].vue").then(m => m.default || m)
  },
  {
    name: loginZZK6EXEGPIMeta?.name ?? "login",
    path: loginZZK6EXEGPIMeta?.path ?? "/login",
    meta: loginZZK6EXEGPIMeta || {},
    alias: loginZZK6EXEGPIMeta?.alias || [],
    redirect: loginZZK6EXEGPIMeta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/login.vue").then(m => m.default || m)
  },
  {
    name: logout2y7kuGoFU4Meta?.name ?? "logout",
    path: logout2y7kuGoFU4Meta?.path ?? "/logout",
    meta: logout2y7kuGoFU4Meta || {},
    alias: logout2y7kuGoFU4Meta?.alias || [],
    redirect: logout2y7kuGoFU4Meta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/logout.vue").then(m => m.default || m)
  },
  {
    name: noticiase7VaHLpbHYMeta?.name ?? "noticias",
    path: noticiase7VaHLpbHYMeta?.path ?? "/noticias",
    meta: noticiase7VaHLpbHYMeta || {},
    alias: noticiase7VaHLpbHYMeta?.alias || [],
    redirect: noticiase7VaHLpbHYMeta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/noticias.vue").then(m => m.default || m)
  },
  {
    name: _91tab_9397SC3gd6PcMeta?.name ?? "profile-settings-tab",
    path: _91tab_9397SC3gd6PcMeta?.path ?? "/profile/settings/:tab()",
    meta: _91tab_9397SC3gd6PcMeta || {},
    alias: _91tab_9397SC3gd6PcMeta?.alias || [],
    redirect: _91tab_9397SC3gd6PcMeta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/profile/settings/[tab].vue").then(m => m.default || m)
  },
  {
    name: _91token_930ycrhvM19HMeta?.name ?? "resetPassword-token",
    path: _91token_930ycrhvM19HMeta?.path ?? "/resetPassword/:token()",
    meta: _91token_930ycrhvM19HMeta || {},
    alias: _91token_930ycrhvM19HMeta?.alias || [],
    redirect: _91token_930ycrhvM19HMeta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/resetPassword/[token].vue").then(m => m.default || m)
  },
  {
    name: licencia9ccz7HxvBbMeta?.name ?? "rules-licencia",
    path: licencia9ccz7HxvBbMeta?.path ?? "/rules/licencia",
    meta: licencia9ccz7HxvBbMeta || {},
    alias: licencia9ccz7HxvBbMeta?.alias || [],
    redirect: licencia9ccz7HxvBbMeta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/rules/licencia.vue").then(m => m.default || m)
  },
  {
    name: manualLNPxFL9owuMeta?.name ?? "rules-manual",
    path: manualLNPxFL9owuMeta?.path ?? "/rules/manual",
    meta: manualLNPxFL9owuMeta || {},
    alias: manualLNPxFL9owuMeta?.alias || [],
    redirect: manualLNPxFL9owuMeta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/rules/manual.vue").then(m => m.default || m)
  },
  {
    name: politicas0mp8IppUlfMeta?.name ?? "rules-politicas",
    path: politicas0mp8IppUlfMeta?.path ?? "/rules/politicas",
    meta: politicas0mp8IppUlfMeta || {},
    alias: politicas0mp8IppUlfMeta?.alias || [],
    redirect: politicas0mp8IppUlfMeta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/rules/politicas.vue").then(m => m.default || m)
  },
  {
    name: terminos4k5m2XPwS8Meta?.name ?? "rules-terminos",
    path: terminos4k5m2XPwS8Meta?.path ?? "/rules/terminos",
    meta: terminos4k5m2XPwS8Meta || {},
    alias: terminos4k5m2XPwS8Meta?.alias || [],
    redirect: terminos4k5m2XPwS8Meta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/rules/terminos.vue").then(m => m.default || m)
  },
  {
    name: myGJMUhaQI3UMeta?.name ?? "schedule-my",
    path: myGJMUhaQI3UMeta?.path ?? "/schedule/my",
    meta: myGJMUhaQI3UMeta || {},
    alias: myGJMUhaQI3UMeta?.alias || [],
    redirect: myGJMUhaQI3UMeta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/schedule/my.vue").then(m => m.default || m)
  },
  {
    name: index3WyeU1RpzgMeta?.name ?? "school-assistance-entrance",
    path: index3WyeU1RpzgMeta?.path ?? "/school/assistance/entrance",
    meta: index3WyeU1RpzgMeta || {},
    alias: index3WyeU1RpzgMeta?.alias || [],
    redirect: index3WyeU1RpzgMeta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/school/assistance/entrance/index.vue").then(m => m.default || m)
  },
  {
    name: indexZ1q96dlZUqMeta?.name ?? "school-assistance-report",
    path: indexZ1q96dlZUqMeta?.path ?? "/school/assistance/report",
    meta: indexZ1q96dlZUqMeta || {},
    alias: indexZ1q96dlZUqMeta?.alias || [],
    redirect: indexZ1q96dlZUqMeta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/school/assistance/report/index.vue").then(m => m.default || m)
  },
  {
    name: indexx6TUrOUW9yMeta?.name ?? "school-sico",
    path: indexx6TUrOUW9yMeta?.path ?? "/school/sico",
    meta: indexx6TUrOUW9yMeta || {},
    alias: indexx6TUrOUW9yMeta?.alias || [],
    redirect: indexx6TUrOUW9yMeta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/school/sico/index.vue").then(m => m.default || m)
  },
  {
    name: adminpiarXeYf0XYIvtMeta?.name ?? "school-tracing-adminpiar",
    path: adminpiarXeYf0XYIvtMeta?.path ?? "/school/tracing/adminpiar",
    meta: adminpiarXeYf0XYIvtMeta || {},
    alias: adminpiarXeYf0XYIvtMeta?.alias || [],
    redirect: adminpiarXeYf0XYIvtMeta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/school/tracing/adminpiar.vue").then(m => m.default || m)
  },
  {
    name: characterization4IeQ6sD5WAMeta?.name ?? "school-tracing-characterization",
    path: characterization4IeQ6sD5WAMeta?.path ?? "/school/tracing/characterization",
    meta: characterization4IeQ6sD5WAMeta || {},
    alias: characterization4IeQ6sD5WAMeta?.alias || [],
    redirect: characterization4IeQ6sD5WAMeta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/school/tracing/characterization.vue").then(m => m.default || m)
  },
  {
    name: coursesOPW10OMFkPMeta?.name ?? "school-tracing-courses",
    path: coursesOPW10OMFkPMeta?.path ?? "/school/tracing/courses",
    meta: coursesOPW10OMFkPMeta || {},
    alias: coursesOPW10OMFkPMeta?.alias || [],
    redirect: coursesOPW10OMFkPMeta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/school/tracing/courses.vue").then(m => m.default || m)
  },
  {
    name: lowPerformanceDJdG7rpLvAMeta?.name ?? "school-tracing-lowPerformance",
    path: lowPerformanceDJdG7rpLvAMeta?.path ?? "/school/tracing/lowPerformance",
    meta: lowPerformanceDJdG7rpLvAMeta || {},
    alias: lowPerformanceDJdG7rpLvAMeta?.alias || [],
    redirect: lowPerformanceDJdG7rpLvAMeta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/school/tracing/lowPerformance.vue").then(m => m.default || m)
  },
  {
    name: performanceiKvyrXH3xOMeta?.name ?? "school-tracing-performance",
    path: performanceiKvyrXH3xOMeta?.path ?? "/school/tracing/performance",
    meta: performanceiKvyrXH3xOMeta || {},
    alias: performanceiKvyrXH3xOMeta?.alias || [],
    redirect: performanceiKvyrXH3xOMeta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/school/tracing/performance.vue").then(m => m.default || m)
  },
  {
    name: resources0KGogyglTDMeta?.name ?? "school-tracing-resources",
    path: resources0KGogyglTDMeta?.path ?? "/school/tracing/resources",
    meta: resources0KGogyglTDMeta || {},
    alias: resources0KGogyglTDMeta?.alias || [],
    redirect: resources0KGogyglTDMeta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/school/tracing/resources.vue").then(m => m.default || m)
  },
  {
    name: indexP4MFeWCo1AMeta?.name ?? "school-transport",
    path: indexP4MFeWCo1AMeta?.path ?? "/school/transport",
    meta: indexP4MFeWCo1AMeta || {},
    alias: indexP4MFeWCo1AMeta?.alias || [],
    redirect: indexP4MFeWCo1AMeta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/school/transport/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93yMERMLUrMKMeta?.name ?? "subject-home-id-tab-subid-slug",
    path: _91_46_46_46slug_93yMERMLUrMKMeta?.path ?? "/subject/home/:id()/:tab()/:subid?/:slug(.*)*",
    meta: _91_46_46_46slug_93yMERMLUrMKMeta || {},
    alias: _91_46_46_46slug_93yMERMLUrMKMeta?.alias || [],
    redirect: _91_46_46_46slug_93yMERMLUrMKMeta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/subject/home/[id]/[tab]/[[subid]]/[...slug].vue").then(m => m.default || m)
  },
  {
    name: testfyUrV7wzG9Meta?.name ?? "test",
    path: testfyUrV7wzG9Meta?.path ?? "/test",
    meta: testfyUrV7wzG9Meta || {},
    alias: testfyUrV7wzG9Meta?.alias || [],
    redirect: testfyUrV7wzG9Meta?.redirect,
    component: () => import("/tmp/8dda472cd6067b3/pages/test.vue").then(m => m.default || m)
  }
]